import React from 'react';

export default function Logo({ className = "w-12 h-12", showText = true }) {
  return (
    <div className="flex items-center select-none">
      {/* Container to handle scaling via className */}
      <div className={`${className} relative flex shrink-0`}>
        <svg
          viewBox="0 0 300 200"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className="w-full h-full"
          style={{ direction: 'ltr' }}
        >
          {/* Car Silhouette - Centered and Slightly Larger */}
          <g transform="translate(70, -65) scale(0.45)">
            <g transform="translate(0,600) scale(0.1,-0.1)" fill="white" stroke="none">
                <path d="M3365 3614 c-491 -54 -757 -124 -1138 -300 l-118 -55 -217 -9 c-338
                -15 -543 -41 -754 -95 -271 -70 -504 -190 -673 -349 l-70 -65 100 66 c350 232
                763 338 1458 372 l188 10 127 59 c289 135 569 218 907 269 171 25 685 25 865
                0 169 -24 343 -58 333 -67 -24 -20 -559 -172 -773 -219 -192 -43 -229 -47
                -575 -75 -299 -24 -430 -33 -1135 -76 -179 -11 -352 -23 -385 -27 l-60 -8 60
                -6 c33 -4 121 -7 196 -8 75 -1 386 -17 690 -37 931 -60 1006 -52 1799 199 383
                121 680 174 913 162 60 -3 83 -2 67 4 -14 5 -95 9 -181 10 l-157 1 -113 54
                c-175 84 -386 137 -684 172 -125 14 -588 27 -670 18z"/>
                <path d="M4830 3294 c-136 -16 -310 -53 -470 -100 -119 -34 -304 -98 -260 -89
                14 3 95 21 180 40 311 69 637 102 915 91 156 -6 283 -18 328 -32 59 -18 87
                -210 47 -317 -26 -68 -95 -143 -166 -181 -69 -36 -35 -32 42 5 35 16 86 52
                113 79 67 67 95 128 99 217 8 139 -52 250 -145 272 -132 31 -484 39 -683 15z"/>
                <path d="M1240 2991 c-145 -47 -248 -138 -289 -256 l-11 -30 18 25 c59 85 137
                145 238 182 47 17 83 21 174 22 l115 1 87 -42 c95 -46 174 -111 220 -182 15
                -25 28 -41 28 -37 0 22 -67 130 -110 177 -117 132 -315 190 -470 140z"/>
                <path d="M4642 2994 c-134 -36 -262 -133 -319 -241 -48 -91 -50 -114 -3 -46
                152 226 431 299 674 176 56 -28 156 -119 187 -170 35 -57 33 -29 -3 39 -101
                190 -336 296 -536 242z"/>
                <path d="M2375 2554 c-354 -17 -571 -36 -588 -53 -28 -28 123 -39 721 -52 428
                -10 637 -10 985 -1 409 11 662 25 696 37 49 18 -61 36 -339 56 -144 10 -1318
                20 -1475 13z"/>
            </g>
          </g>
          
          {/* Text: M FOUR - Centered */}
          <text 
            x="150" 
            y="150" 
            textAnchor="middle" 
            fontFamily="system-ui, -apple-system, sans-serif" 
            fontWeight="900" 
            fontSize="55" 
            letterSpacing="-1"
            className="drop-shadow-lg"
          >
            <tspan fill="#E60000">M</tspan>
            <tspan dx="10" fill="white">FOUR</tspan>
          </text>
        </svg>
      </div>
    </div>
  );
}
